// API Configuration
const resolveBaseUrl = () => {
  const envBaseUrl = import.meta.env.VITE_API_URL ?? import.meta.env.VITE_API_BASE_URL
  if (envBaseUrl) {
    return envBaseUrl
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/api`
  }

  return 'http://localhost:3001/api'
}

const resolveTimeoutMs = () => {
  const raw = import.meta.env.VITE_API_TIMEOUT_MS
  const parsed = raw != null && String(raw).trim() !== '' ? Number(raw) : NaN
  // Default 2 minutes — slow / high-latency links need more than a short 30s cut-off.
  if (Number.isFinite(parsed) && parsed >= 5000) return parsed
  return 120_000
}

export const API_CONFIG = {
  BASE_URL: resolveBaseUrl(),
  TIMEOUT: resolveTimeoutMs(),
};
